export default __webpack_public_path__ + "static/media/apple-icon-114x114.3fff13fb.png";